/**
 * Prix du portail B2B.
 *
 * Le prix porté par un produit (`unit_price`, prix négocié du client) est
 * celui d'UNE CAISSE : sur le lot Uncle Bills, une unité ERP est une caisse
 * et `case_pack` dit combien de pièces elle contient. On achète donc à la
 * caisse — mais personne ne décide d'un achat sur un prix de caisse, d'où
 * l'affichage du prix de la pièce à côté.
 */

/** Prix d'une pièce à l'intérieur de la caisse. */
export function pieceUnitPrice(product) {
    const casePrice = Number(product?.unit_price ?? 0);
    const pack = Number(product?.case_pack ?? 1) || 1;
    if (!Number.isFinite(casePrice) || pack <= 1) return casePrice;
    return casePrice / pack;
}

/** Montant engagé pour la quantité choisie (quantité × prix de la caisse). */
export function lineTotal(product, quantity) {
    const casePrice = Number(product?.unit_price ?? 0);
    const qty = Number(quantity ?? 0);
    if (!Number.isFinite(casePrice) || !Number.isFinite(qty)) return 0;
    return casePrice * qty;
}
